import { ColorsTypeEnum } from "~/utils/enums/colores.enums";

// The colour stored on a training-tag family is a raw hex; it renders through the Tag variant of the same hue.
const TAG_FAMILY_COLOR_TYPE: Record<string, ColorsTypeEnum> = {
  "#18A0FB": ColorsTypeEnum.LIGHT_BLUE,
  "#BF98FD": ColorsTypeEnum.LIGHT_PURPLE,
  "#F08C00": ColorsTypeEnum.LIGHT_ORANGE,
  "#00CE81": ColorsTypeEnum.LIGHT_GREEN,
  "#FF6760": ColorsTypeEnum.LIGHT_RED,
};

export const tagFamilyColorType = (color?: string | null): ColorsTypeEnum | undefined =>
  color ? TAG_FAMILY_COLOR_TYPE[color.toUpperCase()] : undefined;
